import React from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import favicon from '../../static/favicon.png';

const SEO = props => (
  <StaticQuery
    query={detailsQuery}
    render={(data) => {
      const { siteMetadata } = data.site;
      const title = props.title || siteMetadata.title;
      const description = props.description || "";
      const { siteUrl, contact } = siteMetadata;

      // contact.city is stored as "51709 Marienheide" – split into postal code and locality.
      const cityMatch = (contact.city || '').match(/^\s*(\d{5})\s+(.*)$/);
      const postalCode = cityMatch ? cityMatch[1] : undefined;
      const addressLocality = cityMatch ? cityMatch[2] : contact.city;

      // gatsby-plugin-manifest emits this icon to /favicons (see gatsby-config.js).
      const logoUrl = `${siteUrl}/favicons/icon-512x512.png`;

      // Site-wide business info – emitted once (from the Layout's <SEO schema />),
      // never per page, so the LocalBusiness node stays unique.
      const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        // schema.org has no signage-specific type; flag the trade via additionalType.
        additionalType: 'https://de.wikipedia.org/wiki/Werbetechnik',
        '@id': `${siteUrl}/#business`,
        name: siteMetadata.title,
        url: siteUrl,
        logo: logoUrl,
        image: logoUrl,
        telephone: contact.phone,
        email: contact.email,
        address: {
          '@type': 'PostalAddress',
          streetAddress: contact.street,
          postalCode,
          addressLocality,
          addressCountry: 'DE',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 51.072113461374045,
          longitude: 7.5778504265637725,
        },
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'],
            opens: '08:00',
            closes: '16:00',
          },
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: 'Friday',
            opens: '08:00',
            closes: '13:30',
          },
        ],
      };

      return (
        <Helmet
          htmlAttributes={{
            lang: 'de',
          }}
          title={title}
          titleTemplate={`%s | ${siteMetadata.title}`}
          link={[
            { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` },
          ]}
        >
          <meta name="description" content={description}></meta>
          {props.schema && (
            <script type="application/ld+json">
              {JSON.stringify(structuredData)}
            </script>
          )}
        </Helmet>
      );
    }}
  />
);

SEO.defaultProps = {
  lang: 'de',
  meta: [],
  keywords: [],
  schema: false,
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        siteUrl
        contact {
          phone
          email
          street
          city
        }
      }
    }
  }
`;
